import { createPluginFactory, RangeBeforeOptions } from '@udecode/plate-common';

import { ELEMENT_ANCHOR_LINK } from '../../plateTypes';
import { withMyLinks } from './withMyLinks';

export { ELEMENT_ANCHOR_LINK };

export interface AnchorLinkPlugin {
  /**
   * Allow custom config for rangeBeforeOptions.
   *
   * @example
   *   default
   *   {
   *   matchString: ' ',
   *   skipInvalid: true,
   *   afterMatch: true,
   *   }
   */
  rangeBeforeOptions?: RangeBeforeOptions;

  /** NOTE: Disabled for now. Hotkeys to trigger floating link. */
  // triggerFloatingLinkHotkeys?: string | string[];

  /**
   * Keeps selected text on pasting links by default.
   *
   * @default true
   */
  // keepSelectedTextOnPaste?: boolean;
}

/** Enables support for anchor links. */
export const createAnchorLinkPlugin = createPluginFactory<AnchorLinkPlugin>({
  key: ELEMENT_ANCHOR_LINK,
  isElement: true,
  isInline: true,
  withOverrides: withMyLinks,
  options: {
    rangeBeforeOptions: {
      matchString: ' ',
      skipInvalid: true,
      afterMatch: true,
    },
    // keepSelectedTextOnPaste: true,
  },
  deserializeHtml: {
    rules: [{ validNodeName: ['A'] }],
    getNode(el, node) {
      const href = el.getAttribute('href');
      if (!href || !href.startsWith('#')) return;

      const linkId = href.slice(1);
      return {
        type: ELEMENT_ANCHOR_LINK,
        linkId,
        ...node,
      };
    },
  },
});
